const URL = process.env.REACT_APP_API_URL;

module.exports = {
  URL
};
